import React, { useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

export default function DefaultFilter(props) {
	const {
		columnDef,
		localization: globalLocalization,
		icons,
		onFilterChanged
	} = props;
	const localization = { ...globalLocalization };
	const [value, setValue] = useState(() => columnDef.filterValue ?? "");

	function search() {
		onFilterChanged(columnDef.tableData.id, value);
	}

	return (
		<TextField
			style={
				columnDef.type === "numeric"
					? { float: "right", marginTop: 16 }
					: { marginTop: 16 }
			}
			type={columnDef.type === "numeric" ? "number" : "text"}
			value={value ?? ""}
			placeholder={columnDef.filterPlaceholder || ""}
			onInput={event => setValue(event.target.value)}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<Tooltip title={localization.filterTooltip}>
							<icons.Filter />
						</Tooltip>
					</InputAdornment>
				)
			}}
			onBlur={search}
			onKeyPress={event => {
				if (event.key === "Enter") {
					search();
					event.target.blur();
				}
			}}
		/>
	);
}
